import { Grid } from "@mui/material";
import { useEffect } from "react";
import { Control, FieldErrors, UseFormRegister, UseFormReset } from "react-hook-form";
import WSRadioField from "../../Components/Radio/WSRadio";
import config from "../../Config/clientConfig.json";
import { WSView } from "../../Components/View/WSView";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import WSSelectField from "../../Components/Select/WSSelect";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import WSDateField from "../../Components/DateField/WSDateField";

interface OrderInformationProps {
    control: Control<any>;
    errors: FieldErrors;
    register: UseFormRegister<any>;
    id: any;
    reset: UseFormReset<any>;
    
  
  }
  const OrderInformation: React.FC<OrderInformationProps> = ({ control, errors, register, id, reset}) => {
    useEffect(()=>()=>{
      reset()
    },[ id,reset])

    
      

    return(
        <div style={{
            padding: "20px",
            position: "relative",
            margin: "auto",
            marginTop: "4rem",
          }}>
            <Grid container spacing={2}>

            <Grid item container>
            <Grid xs={12} sm={2} >
              <WSView title={"Table No"} />
            </Grid>
            <Grid xs={12} sm={10}>
            <WSSelectField
              rules={{ required: true }}
              {...register("tableno")}
              id="tableno"
              control={control}
              defaultValue={"0"}
              label=""
              name="tableno"
            />
            </Grid>
          </Grid>
            <Grid item xs={12} sm={2} >
              <WSView title={"Waiter Name"} />
            </Grid>
            <Grid item xs={12} sm={6}>
            <WSSelectField
              rules={{ required: true }}
              {...register("waitername")}
              id="waitername"
              control={control}
              defaultValue={"0"}
              label=""
              name="waitername"
            />
            </Grid>
            <Grid item xs={12} sm={4}>
            <WSTextField
            label={""}
            {...register("waitercode")}
            id="waitercode"
            name="waitercode"
            control={control}
            rules={{ required: false }}/>
            </Grid>
            <Grid item xs={12} sm={2} >
              <WSView title={"First Name"} />
            </Grid>
           
            <Grid item xs={12} sm={10}>
            <WSTextField
            label={""}
            {...register("firstname")}
            id="firstname"
            name="firstname"
            control={control}
            rules={{ required: false }}/>
            </Grid>
            <Grid item xs={12} sm={2} >
              <WSView title={"Last Name"} />
            </Grid>
           
            <Grid item xs={12} sm={10}>
            <WSTextField
            label={""}
            {...register("lastname")}
            id="lastname"
            name="lastname"
            control={control}
            rules={{ required: false }}/>
            </Grid>
            <Grid item xs={12} sm={2} >
              <WSView title={"#Adult"} />
            </Grid>
            <Grid item xs={12} sm={4}>
            <WSTextField
            label={""}
            {...register("adult")}
            id="adult"
            name="adult"
            control={control}
            rules={{ required: false }}/>
            </Grid>
            <Grid item xs={12} sm={2} >
              <WSView title={"#Child"} />
            </Grid>
            <Grid item xs={12} sm={4}>
            <WSTextField
            label={""}
            {...register("child")}
            id="child"
            name="child"
            control={control}
            rules={{ required: false }}/>
            </Grid>
            <Grid item xs={12} sm={2} >
              <WSView title={"Date"} />
            </Grid>
           
            <Grid item xs={12} sm={10}>
            <WSDateField
              id="date"
              name="date"
              label=""
              dateFormat="D/MM/YYYY"
              control={control}
              defaultValue={null}
              rules={{ required: true }}
              labelType="Normal"
            />
            </Grid>
         
          <Grid item xs={12} sm={2} >
              <WSView title={"Remark"} />
            </Grid>
           
            <Grid item xs={12} sm={10}>
            <WSTextField
            label={""}
            {...register("remark")}
            id="remark"
            name="remark"
            control={control}
            rules={{ required: false }}/>
            </Grid>
            <Grid item xs={12} sm={2} >
              <WSView title={"Citizen Id#"} />
            </Grid>
           
            <Grid item xs={12} sm={10}>
            <WSTextField
            label={""}
            {...register("citizenid")}
            id="citizenid"
            name="citizenid"
            control={control}
            rules={{ required: false }}/>
            </Grid>
         
               
        </Grid>
        </div>
    )
}
export default OrderInformation